import { text } from '@modules/home/text';
import { useConvexAuth } from 'convex/react';
import { ComponentType } from 'react';

export interface HomeProps {
  isLoading: boolean;
  welcomeTitle: string;
  welcomeSubtitle: string;
  hubIntro: string;
  gardensLabel: string;
  gardensHint: string;
  plantsLabel: string;
  plantsHint: string;
  settingsLabel: string;
  settingsHint: string;
  onOpenGardens: () => void;
  onOpenPlants: () => void;
  onOpenSettings: () => void;
}

interface HomeContainerProps {
  View: ComponentType<HomeProps>;
  onNavigate: (path: string) => void;
}

export function HomeContainer({ View, onNavigate }: HomeContainerProps) {
  const { isLoading } = useConvexAuth();

  return (
    <View
      isLoading={isLoading}
      welcomeTitle={text.welcome}
      welcomeSubtitle={text.subtitle}
      hubIntro={text.hubIntro}
      gardensLabel={text.openGardens}
      gardensHint={text.openGardensHint}
      plantsLabel={text.openPlants}
      plantsHint={text.openPlantsHint}
      settingsLabel={text.openSettings}
      settingsHint={text.openSettingsHint}
      onOpenGardens={() => onNavigate('/gardens')}
      onOpenPlants={() => onNavigate('/plants')}
      onOpenSettings={() => onNavigate('/settings')}
    />
  );
}
